const TRANSACTIONS = {
  UPDATE_QUERIES_FOR_TRANSACTION: 'TRANSACTIONS::UPDATE_QUERIES_FOR_TRANSACTION',
  RESET_INITIAL_DATA: 'TRANSACTIONS::RESET_INITIAL_DATA'
};
export default TRANSACTIONS
